import { render, staticRenderFns } from "./HerpeticNeuralgia.vue?vue&type=template&id=74360458&scoped=true"
import script from "./HerpeticNeuralgia.vue?vue&type=script&lang=js"
export * from "./HerpeticNeuralgia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74360458",
  null
  
)

export default component.exports